import React from 'react';
import ConsentBanner from './src/components/consent-banner';
import { gpcEnabled, hasConsent, loadTrackers } from './src/components/consent';

// Returning visitor with the consent cookie: load GTM on first render,
// after React hydration. New visitors get nothing until they click Accept.
// GPC browsers get nothing, period. (CA privacy hardening, July 2026.)
export const onInitialClientRender = () => {
	if (gpcEnabled()) return;
	if (hasConsent()) loadTrackers();
};

// Logs when the client route changes
export const onRouteUpdate = ({ location, prevLocation }) => {
	// First-party attribution capture — intentionally NOT consent-gated:
	// data the visitor's browser stores about their own visit to our site
	// (landing URL, current path) is first-party and stays outside the gate.
	if (
		typeof window !== 'undefined' &&
		window.localStorage &&
		!window.localStorage.getItem('lNdUrL')
	) {
		window.localStorage.setItem('lNdUrL', location.href);
		window.localStorage.setItem('lNdUrLDtIme', new Date());
	}

	window.localStorage.setItem('crNtPaTH', location.href);
	window.localStorage.setItem(
		'prevPaTHnAme',
		prevLocation ? prevLocation.href : null
	);

	// Re-emit the dataLayer event the removed gatsby-plugin-google-tagmanager
	// used to push, so SPA-pageview GTM triggers keep working. Harmless no-op
	// until/unless GTM has loaded (dataLayer is just an array before then).
	setTimeout(() => {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({ event: 'gatsby-route-change' });
	}, 50);
};

// Render the consent banner on every page (mirrors gatsby-ssr.js).
export const wrapPageElement = ({ element }) => (
	<>
		{element}
		<ConsentBanner />
	</>
);
